import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';
import { teipTranslation } from './locales/teip';
const companyLogged = process.env.VUE_APP_I18N_LOCALE || 'teip';
Vue.use(VueI18n);

type CompanyTranslations = {
  data: {
    name: string,
    menu: {
      commerce: {
        plural: string,
        singular: string,
      }
      company: {
        plural: string,
        singular: string,
      }
    }
  }
}

const companyTranslations: CompanyTranslations = JSON.parse(
  window.localStorage.getItem('company-translations') || '{}'
);

const messages = teipTranslation as LocaleMessages;

if (Object.entries(companyTranslations).length > 0) {
  messages[companyTranslations.data.name] = {
    menu: companyTranslations.data.menu,
    commerce: messages.teip.commerce,
    company: messages.teip.company,
  };
}

export default new VueI18n({
  locale: companyLogged,
  fallbackLocale: 'teip',
  silentFallbackWarn: true,
  messages,
});
